import { type FetchLike, type Middleware, type WretchOptions } from 'wretch';
import { readLosslessJson } from '@/helpers/lossless-json';

/** Reads the answer with integers past 2^53 kept exact, as `bigint`, where `response.json()` would round them. */
export const losslessJsonMiddleware: Middleware = () => (next: FetchLike) => (url: string, opts: WretchOptions) =>
  next(url, opts).then((response) => {
    response.json = async () => readLosslessJson(await response.text());
    return response;
  });
